import type { HTMLSerializeOptions } from '@lumapps/wrex/serialization/html/toHTML/types';

export const COLUMNS_ELEMENTS: HTMLSerializeOptions['elements'] = {
    columns: (_, children) => `<div class="wrex-content-columns">${children}</div>`,
    column: (_, children) => `<div class="wrex-content-column">${children}</div>`,
};
